/**
 * The one way to turn a file id into viewable bytes (SEC-04, §7в).
 *
 * Two eras coexist in one conversation: rows whose envelope carries a key
 * (`file_key`) name a sealed blob the server cannot open; rows without one
 * are from before attachments were encrypted and come back as plain bytes.
 * The key decides — not a guess about the content.
 */
import { api } from './api';
import { openFile } from './fileCrypto.mjs';

export async function fetchFileBytes(fileId, fileKey = null) {
  const token = localStorage.getItem('voxiox_token');
  const r = await fetch(api.getFileUrl(fileId), { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const raw = new Uint8Array(await r.arrayBuffer());
  if (!fileKey) return raw;
  const open = openFile(raw, fileKey);
  // A sealed blob that does not open is a fact to show, not to spin over:
  // wrong key, tampered bytes, or a future format this build cannot read.
  if (!open) throw new Error('вложение не расшифровалось');
  return open;
}

/** Same, as an object URL with the envelope's MIME — what <img>/<audio> want. */
export async function fetchFileObjectURL(fileId, fileKey = null, mime = null) {
  const bytes = await fetchFileBytes(fileId, fileKey);
  return URL.createObjectURL(new Blob([bytes], mime ? { type: mime } : undefined));
}
